import { memo, useCallback, useMemo, useReducer } from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import RegisterPackage from '../registration/RegisterPackage';
import RegisterContact from '../registration/RegisterContact';
import RegisterConfirm from '../registration/RegisterConfirm';
import RegisterComplete from '../registration/RegisterComplete';

const getSteps = () => ['Select Package', 'Contact info', 'Payment & Confirmation'];

const reducer = (state, action) => {
  if (action.type === 'RESET') {
    return { activeStep: 0, skipped: {}, data: {} };
  }

  const activeStep = state.activeStep + (action.type === 'BACK' ? -1 : 1);
  let { skipped, data } = state;

  if (action.type !== 'BACK') {
    skipped = { ...skipped, [state.activeStep]: action.type === 'SKIP' };
  }

  if (action.data) {
    data = { ...data, ...action.data };
  }

  return { activeStep, skipped, data };
};

const RegisterStepper = () => {
  const [stepperState, dispatch] = useReducer(reducer, {
    activeStep: 0,
    skipped: {},
    data: {},
  });

  const { activeStep, data } = stepperState;
  const steps = getSteps();

  const reset = () => dispatch({ type: 'RESET' });
  const nextStep = useCallback((payload) => dispatch({ type: 'NEXT', data: payload }), []);

  const stepperProps = useMemo(
    () => ({ stepperState, stepCount: steps.length, dispatch }),
    [stepperState, steps.length]
  );

  // ─── Content by step ───────────────────────────────────────────────────────
  const content = useMemo(() => {
    switch (activeStep) {
      case 0:
        return <RegisterPackage data={data} nextStep={nextStep} stepperProps={stepperProps} />;
      case 1:
        return <RegisterContact data={data} nextStep={nextStep} stepperProps={stepperProps} />;
      case 2:
        return <RegisterConfirm data={data} nextStep={nextStep} stepperProps={stepperProps} />;
      case steps.length:
        return <RegisterComplete data={data} reset={reset} stepperProps={stepperProps} />;
      default:
        return 'Unknown step';
    }
  }, [activeStep, data, nextStep, stepperProps, reset, steps.length]);

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ width: '100%', bgcolor: '#fff' }} id="register-stepper">
      <Stepper activeStep={activeStep} alternativeLabel
        sx={{
          '& .MuiStepIcon-root.Mui-active': {
            color: '#fff',          
          },
          '& .MuiStepIcon-root.Mui-active circle': {
            fill: '#9aeeda',       
          },
          '& .Mui-completed': {
            fill: '#9aeeda',
          }

        }}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={!stepperState.skipped[index] && index < activeStep}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Typography component="div" sx={{ mt: 2 }}>
        {content}
      </Typography>
    </Box>
  );
};

export default memo(RegisterStepper);